import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import CountdownTimer from './sections/CountdownTimer';
import ProblemSection from './sections/ProblemSection';
import SolutionSection from './sections/SolutionSection';
import OfferSection from './sections/OfferSection';
import CaseStudiesSection from './sections/CaseStudiesSection';
import TestimonialSection from './sections/TestimonialSection';
import FinalCTASection from './sections/FinalCTASection';
import Footer from './sections/Footer';
import StickyButton from './components/StickyButton';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-green-900 to-blue-900">
      <HeroSection />
      <CountdownTimer />
      <ProblemSection />
      <SolutionSection />
      <OfferSection />
      <CaseStudiesSection />
      <TestimonialSection />
      <CountdownTimer />
      <FinalCTASection />
      <Footer />
      <StickyButton />
    </div>
  );
};

export default LandingPage;